import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URLS } from '../constants/URLS';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportingService {

  constructor(
    private http: HttpClient
  ) { }

  getReportTypes(){
    return this.http.get<any>(URLS.getReportTypes)
      .pipe(
        map(result =>{
          if(result.Success){
            return result.Data;
          }else{
            return undefined
          }
        }),catchError(errRes => {
          return throwError(errRes);
        })
      )
  }

  reportAbuse(requestBody:any):Observable<any>{
    return this.http.post<any>(URLS.reportAbuse, requestBody)
      .pipe(
        map(result => {
          if(result){
            return result
          }else{
            return undefined
          }
        }), catchError(errRes => {
          return throwError(errRes);
        })
      )
  }
}
